import { Link, useLocation } from 'react-router-dom';
import SocialMedia from '../socialMedia/SocialMedia';
import LogoLink from '../logoLink/LogoLink';

import routes from '../../routes';
import './footer.scss';
import './mediaFooter.scss';
import { useMemo } from 'react';
import i18n from '../../i18n';

const t = i18n.t;

const Footer = () => {
  const location = useLocation()
  const showAbroad = useMemo(() => {
    return !([routes.tickets, routes.ufc308vote, routes.ufc308voteThankyou].includes(location.pathname))
  }, [location]);

  return (
    <footer className='footer'>
      <div className='container'>
        {showAbroad && <h4 className='footer__appeal'>
          {t('components.footer.appeal.text1')} <br className='footer__appeal__divider1' /> {t('components.footer.appeal.text2')}{' '}
          <br className='footer__appeal__divider' />
          <a
            href='https://welcome.ufcfightpass.com/region/russia'
            target='_blank'
            className='footer__appeal_link-red'
            rel='noreferrer'
          >
            welcome.ufcfightpass.com
          </a>
        </h4>}
        <div className='footer__wrapper footer__wrapper_ufc'>
          <div className='footer__left-column'>
            <LogoLink colorOfLogo='white' logoClass='footer__logo'></LogoLink>

            <div className='footer__sole-trader footer__sole-trader_768px'>
              <p className='footer__info paragraph paragraph_grey-secondary'>{t('components.footer.info.indiv_enter')}{' '}</p>
              <p className='footer__info paragraph paragraph_grey-secondary'>{' '}{t('components.footer.info.inn')}{' '}</p>
              <p className='footer__info paragraph paragraph_grey-secondary'>{t('components.footer.info.ogrin')}</p>
            </div>
          </div>

          <div className='footer__contacts'>
            <div className='footer__chapter'>
              <h4 className='footer__header h2-mobile'>{t('components.footer.blocks.ufc.header')}</h4>
              <ul className='footer__list'>
                <li className='footer__list-item paragraph paragraph_light-grey'>
                  <a className='footer__link' target='_blank' href='https://ufc.ru/about/sport' rel='noreferrer'>
                    {t('components.footer.blocks.ufc.mma')}
                  </a>
                </li>
                <li className='footer__list-item paragraph paragraph_light-grey'>
                  <a className='footer__link' target='_blank' href='https://ufc.ru/about/community' rel='noreferrer'>
                    {t('components.footer.blocks.ufc.social')}
                  </a>
                </li>
                <li className='footer__list-item paragraph paragraph_light-grey'>
                  <a className='footer__link' target='_blank' href='https://ufc.com/careers' rel='noreferrer'>
                    {t('components.footer.blocks.ufc.vacancy')}
                  </a>
                </li>
                <li className='footer__list-item paragraph paragraph_light-grey'>
                  <a
                    className='footer__link'
                    target='_blank'
                    href='https://ufcstorerussia.ru/?utm_source=ufc'
                    rel='noreferrer'
                  >
                    {t('components.footer.blocks.ufc.shop')}
                  </a>
                </li>
              </ul>
            </div>
            <div className='footer__chapter'>
              <h4 className='footer__header h2-mobile'>{t('components.footer.blocks.contacts.header')}</h4>
              <ul className='footer__list'>
                <li className='footer__list-item paragraph paragraph_light-grey'>
                  <a className='footer__link' href='https://ufc.ru/partners' target='_blank' rel='noreferrer'>
                    {t('components.footer.blocks.contacts.partners')}
                  </a>
                </li>
                <li className='footer__list-item paragraph paragraph_light-grey'>
                  <a
                    className='footer__link'
                    target='_blank'
                    href='https://access.ufc.com/media_users/sign_in'
                    rel='noreferrer'
                  >
                    {t('components.footer.blocks.contacts.press_center')}
                  </a>
                </li>
              </ul>
            </div>
            <div className='footer__chapter'>
              <h4 className='footer__header h2-mobile'>{t('components.footer.blocks.law.header')}</h4>
              <ul className='footer__list'>
                <li className='footer__list-item paragraph paragraph_light-grey'>
                  <Link to={routes.agreement} className='footer__link'>
                    {t('components.footer.blocks.law.agreement')}
                  </Link>
                </li>
                <li className='footer__list-item paragraph paragraph_light-grey'>
                  <Link to={routes.privacy} className='footer__link'>
                    {t('components.footer.blocks.law.privacy')}
                  </Link>
                </li>

                <li className='footer__list-item paragraph paragraph_light-grey'>
                  <Link to={routes.personalPolicy} className='footer__link'>
                    {t('components.footer.blocks.law.personal_policy')}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className='footer__wrapper footer__wrapper_social-media'>
          <p className='footer__info paragraph paragraph_grey-secondary'>
            {t('components.footer.info.all_rights_reserved')}
          </p>
          <div className='footer__sole-trader footer__sole-trader_320px'>
            <p className='footer__info paragraph paragraph_grey-secondary footer__info_sole-trader'>
              {t('components.footer.info.indiv_enter')}{' '}
            </p>
            <p className='footer__info paragraph paragraph_grey-secondary footer__info_sole-trader'>
              {' '}
              {t('components.footer.info.inn')}
            </p>
            <p className='footer__info paragraph paragraph_grey-secondary footer__info_sole-trader'>
              {t('components.footer.info.ogrin')}
            </p>
          </div>
          <SocialMedia
            specificWrapperClass='social-media_footer'
            specificItemClass='social-media__link_grey-secondary'
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
